import { useState, useEffect } from 'react';


function handleOption(opt) {
	let newList = [];
	function work(opt) {
		if (Array.isArray(opt)) {
			opt.forEach(work);
		} else if (opt instanceof Object) {
			Object.values(opt).forEach(work);
		} else {
			newList.push(opt);
		}
	}
	work(opt);
	return newList;
}


//缓存处理
export const cacheCtx={
	_map:new Map(),
	getCache(ql,params){
		//缓存处理
		let cacheKey=JSON.stringify(params);
		if(this._map.has(ql)){
			let cacheList=this._map.get(ql);
			if(cacheList[cacheKey]){
				return cacheList[cacheKey]
			}else{
				console.log('未获取到',cacheList,cacheKey)
			}
		}

	},
	setCache(ql,params,res){
		let cacheKey=JSON.stringify(params);
		let cacheList=this._map.get(ql)
		if(cacheList){
			cacheList[cacheKey]=res;
		}else{
			this._map.set(ql,{[cacheKey]:res})
		}
	}
}

function useBaseFetch(ql,defaultData={}) {
	//初始数据
	let [ data, setData ] = useState(defaultData);
	let [ loading, setLoading ] = useState(defaultData?false:true);
	let [ error, setError ] = useState(null);
	//mandatory是否强制更新
	async function fetch({ params, onError, onSuccess, updateQuery,mandatory=false, title = '请求' }) {
		let res=!mandatory?cacheCtx.getCache(ql,params):null;
		setError(null);
		if(!res){
			// 初始数据
			setLoading(true);
			//setData({});
			res = await ql(params).catch(function(error) {
				setLoading(false);
				setError(error.message);
				onError && onError({ type: 'error', message: `${error.message || error.msg}` });
				throw error;
			});
			cacheCtx.setCache(ql,params,res)
			onSuccess && onSuccess({ type: 'success', message: `${title}成功` }, res);
			setLoading(false);
		}
		if (updateQuery) {
			res = updateQuery(data, res, params);
		}
		setData(res);
		return res;
	}
	//更新缓存数据
	function updateCache(fun){
		setData(fun(data))
	}
	return { fetch, data, loading, error, setError,updateCache };
}
export function useQuery(ql) {
	return useBaseFetch(ql);
}
//初始带入数据
export function useAutoQuery(ql, { title, onSuccess, onError, mandatory,hold,defaultData, ...params }) {
	let isDefault=false;
	let cacheData=!mandatory?cacheCtx.getCache(ql,params):undefined;
	let context = useBaseFetch(ql,defaultData || cacheData);
	//初次需要判断是否存在 defaultData
	useEffect(() => {
		//是否等待
		if (!hold && !defaultData) {
			isDefault=true
			context.fetch({ params, title, onSuccess, onError,mandatory });
		}
	},[]);
	//状态改变时
	useEffect(() => {
		//是否等待
		if (!hold && !isDefault) {
			context.fetch({ params, title, onSuccess, onError,mandatory });
		}
	}, handleOption(params));
	return {
		...context,
		fetchMore: (newParams, updateQuery) => {
			context.fetch({ params: Object.assign({}, params, newParams), title, onSuccess, onError, updateQuery,mandatory });
		},
		update: () => {
			context.fetch({ params, title, onSuccess, onError });
		}
	};
}